<script>
import { Sketch } from 'vue-color'
export default {
  components: { Sketch },
  props: ['item', 'isnew'],
  data() {
    return {
      loading: true,
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          website_id: '',
        },
      },
      website: {},

      glob_color: '#3bafda',
      preset_colors: [
        '#3bafda',
        '#ff758e',
        '#37bd85',
        '#6572b8',
        '#ffc425',
        '#666666',
        '#ff8a23',
        '#90C3D6',
      ],
    }
  },
  watch: {
    'item.website': { handler: function(n, o) {
      this.filters.wheres.website_id = n;
      this.fetchData();
    }, immediate: true },
  },
  created() {

  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/websites/fetch', {params: this.filters}).then(res => {
        if(res.data.data.length == 1) {
          this.website = res.data.data[0];
        } else {
          this.$noty.warning("Store categories could not be found.");
        }
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    changeColor(id) {
      this.item.colors[id] = this.glob_color.hex;
    },
  }
}
</script>

<template>
  <div>

    <h5 class="section-header mb-3"><Icon icon="ri:shopping-basket-2-line" /> Product details</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Multi" Title="Categories :" v-model="item.categories" :Options="website.store_categories"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Money" v-model="item.price" Title="Price :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Number" v-model="item.stock" Title="Stock Remaining :" Definition="-1 for unlimited" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Number" v-model="item.max_per_order" Title="Max per order :" Definition="-1 for unlimited" Required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" v-model="item.title" Title="Title :" required></w-field>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label>Description :</label>
          <component is="CkRichEditor" v-model="item.description"></component>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="d-block">Colors :</label>
          <div v-for="(color, color_i) in item.colors" :key="'b'+color_i" class="row align-items-end">
            <div class="col-sm" data-aos="fade-zoom-in">
              <div class="form-group">
                <div class="dropdown">
                  <input :id="'field-oname'+color_i" name="name" type="text" class="form-control dropdown-toggle" id="dropdownMenuButton" v-model="item.colors[color_i]" data-toggle="dropdown" @click="glob_color = item.colors[color_i]" :style="'background-color:'+item.colors[color_i]">
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <Sketch v-model="glob_color" :preset-colors="preset_colors" @input="changeColor(color_i)" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm _w-70 _w-m-70">
              <button class="btn btn-white mb-2" type="button" v-tippy content="Delete" @click="item.colors.splice(color_i, 1);$forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
            </div>
          </div>
          <button class="btn btn-light" type="button" @click="item.colors.push(['']);$forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add color</button>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="d-block">Sizes :</label>
          <div v-for="(size, size_i) in item.sizes" :key="'b'+size_i" class="row align-items-end">
            <div class="col-sm" data-aos="fade-zoom-in">
              <div class="form-group">
                <div class="dropdown">
                  <input :id="'field-oname'+size_i" name="name" type="text" class="form-control" v-model="item.sizes[size_i]">
                </div>
              </div>
            </div>
            <div class="col-sm _w-70 _w-m-70">
              <button class="btn btn-white mb-2" type="button" v-tippy content="Delete" @click="item.sizes.splice(size_i, 1);$forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
            </div>
          </div>
          <button class="btn btn-light" type="button" @click="item.sizes.push(['']);$forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add size</button>
        </div>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
